import { logger } from '@fiverr-private/perseus';

export const CLIENT_TIMEOUT_STATUS = 499;

class Logger {

    constructor(requestContext) {
        this.requestContext = requestContext;
    }

    error(error, data = {}) {
        if (data.responseStatus === CLIENT_TIMEOUT_STATUS) {
            return;
        }

        logger.error(error, {requestContext: this.requestContext, ...data});
    }

    warn(message, data = {}) {
        logger.warn({message, requestContext: this.requestContext, ...data});
    }
}

export default Logger;
